import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import { withTranslation } from 'react-i18next';

import FiltersActions from '../../../../actions/FiltersActions';

import Currencies from '../../../../utils/Currencies';

import FiltersConstants from '../../../../constants/FiltersConstants';
import Analytics from 'arbitrip-common/client/analytics';

const isIntegerRegex = /^[1-9]\d*$/;

const PriceFilter = createClass({
	displayName: 'PriceFilter',

	componentDidMount: function () {
		setTimeout(FiltersActions.updateCurrencies);
	},

	onMaxPricePerNightChange: function (e) {
		this.onPricePerNightChange(e, true);
	},

	onMinPricePerNightChange: function (e) {
		this.onPricePerNightChange(e, false);
	},

	onPricePerNightChange: function (e, isMax) {
		const price = e.target.value;
		let { profile, max_price, min_price } = this.props;
		const { display_currency } = this.props.profile;
		const _self = this;

		if ((price === '' || isIntegerRegex.test(price)) && _self.props.filter !== Number(price)) {
			const current_price = Number(price);
			if (isMax && min_price > current_price) {
				min_price = current_price;
			}

			if (!isMax && max_price && current_price > max_price) {
				max_price = current_price;
			}

			if (isMax) {
				FiltersActions.filterByPrice(min_price, current_price);
			} else {
				FiltersActions.filterByPrice(current_price, max_price);
			}
			setTimeout(function () {
				if (isMax) {
					FiltersActions.filterByPrice(min_price, current_price);
				} else {
					FiltersActions.filterByPrice(current_price, max_price);
				}
			}, 10);

			const filter_value = Currencies.getPriceWithCurrency(current_price, display_currency);
			Analytics.actions.interactions.filteredResults(
				profile,
				FiltersConstants.FILTER_METHOD.PRICE,
				`${isMax ? 'max' : 'min'}${filter_value}`,
			);
		}
	},

	onClearClick: function (e) {
		const { profile, max_price, min_price } = this.props;

		if (max_price || min_price) {
			FiltersActions.filterByPrice(0, 0);
			setTimeout(function () {
				FiltersActions.filterByPrice(0, 0);
			}, 10);
			Analytics.actions.interactions.filteredResults(profile, FiltersConstants.FILTER_METHOD.PRICE, 'None');
		}
	},

	render: function () {
		const { t } = this.props;
		const { profile, max_price, min_price } = this.props;
		const { display_currency } = profile;

		const currencySymbol = Currencies.getSymbol(display_currency);
		const maxPriceText = max_price || '';
		const maxPriceInputClass = `form-control${max_price ? '' : ' empty'}`;

		const minPriceText = min_price || '';
		const minPriceInputClass = `form-control${min_price ? '' : ' empty'}`;

		return (
			<div className="filter" data-testid="filter-max-price">
				<label className="filter-title" htmlFor="hotel-price-input">
					{t('MaximumPricePerNight')}
				</label>

				<div className="prices-wrapper">
					{/* <div className="currency-input-wrapper">
						<input
							id="hotel-price-input"
							type="text"
							className={minPriceInputClass}
							placeholder={t('Filters.Min')}
							aria-describedby="sizing-addon2"
							aria-label={`Minimum Price Per Night, ${currencySymbol}`}
							value={minPriceText}
							onChange={this.onMinPricePerNightChange}
							maxLength="8"
						/>
						<div className="currency-icon" id="sizing-addon2">
							{currencySymbol}
						</div>
					</div> */}

					<div className="currency-input-wrapper">
						<input
							id="hotel-price-input"
							type="text"
							className={maxPriceInputClass}
							placeholder={t('Filters.Max')}
							aria-describedby="sizing-addon2"
							aria-label={`Maximum Price Per Night, ${currencySymbol}`}
							value={maxPriceText}
							onChange={this.onMaxPricePerNightChange}
							maxLength="8"
						/>
						<div className="currency-icon" id="sizing-addon2">
							{currencySymbol}
						</div>
					</div>
				</div>

				<button className="clear-button" onClick={this.onClearClick} aria-label="Clear" />
				<button
					className="clear-button-wrap"
					onClick={this.onClearClick}
					aria-label={t('ClearMaximumPricePerNight')}
				>
					<div className="clear-button-img" />
				</button>
			</div>
		);
	},
});

PriceFilter.propTypes = {
	max_price: PropTypes.any.isRequired,
	min_price: PropTypes.any.isRequired,
	profile: PropTypes.object.isRequired,
};

export default withTranslation()(PriceFilter);
